import types from "../types";

const initialState = {
  franchises: null,
  pastChecklists: null,
  checklistsCompletedChart: null,
  checklistsOnTimeChart: null,
  checklistsPassedChart: null,
  customerSatisfactionChart: null,
  additionalFeedback: null,
  calendar: null,
  statistics: null,
  users: null,
  performance: {},
  isFetching: false,
  limitReached: false,
  status: "OK",
};

const checklistReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.FETCHING_FRANCHISES:
      return {
        ...state,
        isFetching: true,
        status: "OK",
      };
    case types.FRANCHISES_FETCHED:
      return {
        ...state,
        isFetching: false,
        franchises: payload,
      };
    case types.ERROR_FETCHING_FRANCHISES:
      return {
        ...state,
        isFetching: false,
        status: "ERROR",
      };

    case types.FETCHING_PAST_CHECKLISTS:
      return {
        ...state,
        isFetching: true,
        status: "OK",
      };
    case types.PAST_CHECKLISTS_FETCHED:
      return {
        ...state,
        isFetching: false,
        pastChecklists: payload,
      };
    case types.ERROR_FETCHING_PAST_CHECKLISTS:
      return {
        ...state,
        isFetching: false,
        status: 'ERROR',
      };

    case types.FETCHING_USERS:
      return {
        ...state,
        isFetching: true,
        status: "OK",
      };
    case types.USERS_FETCHED:
      return {
        ...state,
        users: payload,
        isFetching: false,
      };
    case types.ERROR_FETCHING_USERS:
      return {
        ...state,
        isFetching: false,
        status: "ERROR",
      };

    case types.FETCHING_PERFORMANCE_DATA:
      return {
        ...state,
        isFetching: true,
        status: 'OK',
      }
    case types.PERFORMANCE_DATA_FETCHED:
      return {
        ...state,
        isFetching: false,
        performance: {
          ...state.performance,
          [payload[0]]: payload[1],
        },
      }
    case types.DATA_ALREADY_EXISTS: {
      return {
        ...state,
        isFetching: false,
        status: 'OK',
      }
    }
    case types.ERROR_FETCHING_PERFORMANCE_DATA:
      return {
        ...state,
        status: 'ERROR',
        isFetching: false,
      };

    case types.CREATING_FRANCHISE:
      return {
        ...state,
        isFetching: true,
        status: "OK",
      };
    case types.FRANCHISE_CREATED:
      return {
        ...state,
        isFetching: false,
        status: 'OK',
      };
    case types.ERROR_CREATING_FRANCHISE:
      return {
        ...state,
        status: 'ERROR',
        isFetching: false,
      };

    case types.CREATING_CHECKLIST:
      return {
        ...state,
        isFetching: true,
        status: "OK",
      };
    case types.CHECKLIST_CREATED:
      const newFranchises = { ...state.franchises };
      if (payload.locations[0].location === "general") {
        payload.locations[0].franchise.forEach(franchise => {
          if (newFranchises[franchise].generalChecklists.filter(checklist => checklist.name === payload.name).length === 0) {
            newFranchises[franchise].generalChecklists.push({
              ...payload.checklist,
              name: payload.name,
            });
          } else {
            newFranchises[franchise].generalChecklists.forEach((checklist, index) => {
              if (checklist.name !== payload.name) return;
              newFranchises[franchise].generalChecklists[index] = {
                ...payload.checklist,
                name: payload.name,
              }
            })
          }
        });
      } else {
        payload.locations.forEach(location => {
          newFranchises[location.franchise].locations.forEach(
            (franchiseLocation, index) => {
              if (franchiseLocation.address === location.location) {
                if (newFranchises[location.franchise].locations[
                  index
                ].locationSpecificChecklists.filter(checklist => checklist.name === payload.name).length === 0) {
                  newFranchises[location.franchise].locations[
                    index
                  ].locationSpecificChecklists.push({
                    ...payload.checklist,
                    name: payload.name,
                  });
                } else {
                  newFranchises[location.franchise].locations[
                    index
                  ].locationSpecificChecklists.forEach((checklist, index2) => {
                    if (checklist.name !== payload.name) return;
                    newFranchises[location.franchise].locations[
                      index
                    ].locationSpecificChecklists[index2] = {
                      ...payload.checklist,
                      name: payload.name,
                    };
                  })
                }
              }
            }
          );
        });
      }
      return {
        ...state,
        franchises: newFranchises,
        isFetching: false,
      };
    case types.ERROR_CREATING_CHECKLIST:
      return {
        ...state,
        isFetching: false,
        status: 'ERROR',
      };

    case types.DELETING_CHECKLIST:
      return {
        ...state,
        isFetching: true,
        status: "OK",
      }
    case types.CHECKLIST_DELETED:
      const newFranchisesDelete = {...state.franchises}
      if (payload.type === 'generalChecklists') {
        const newGeneralChecklists = newFranchisesDelete[payload.franchise].generalChecklists.filter(checklist => checklist.name !== payload.name)
        newFranchisesDelete[payload.franchise].generalChecklists = newGeneralChecklists;
      } else {
        newFranchisesDelete[payload.franchise].locations.forEach((location, index) => {
          if (location.address !== payload.location) return;
          const newLocationSpecificChecklists = location.locationSpecificChecklists.filter(checklist => checklist.name !== payload.name);
          newFranchisesDelete[payload.franchise].locations[index].locationSpecificChecklists = newLocationSpecificChecklists;
        })
      }
      return {
        ...state,
        isFetching: false,
        franchises: newFranchisesDelete,
      }
    case types.ERROR_DELETING_CHECKLIST:
      return {
        ...state,
        status: payload,
        isFetching: false,
        status: "ERROR",
      }

    case types.ADDING_USER_LOCATION:
      return {
        ...state,
        isFetching: true,
        status: 'OK'
      }
    case types.USER_LOCATION_ADDED:
      const newLocationUpdateFranchises = { ...state.franchises };
      state.franchises[payload.franchise].locations.forEach((location, index) => {
        if (location.address !== payload.location) return;
        newLocationUpdateFranchises[payload.franchise].locations[index].managers = payload.locationManagers;
        newLocationUpdateFranchises[payload.franchise].locations[index].technicianAssigned = payload.technicianAssigned;
      })
      const newLocationUpdateUsers = { ...state.users };
      newLocationUpdateUsers[payload.uid].assignedLocations = payload.locations;
      return {
        ...state,
        isFetching: false,
        status: 'OK',
        franchises: newLocationUpdateFranchises,
        users: newLocationUpdateUsers,
      }
    case types.ERROR_ADDING_USER_LOCATION:
      return {
        ...state,
        isFetching: false,
        status: 'ERROR',
      }

    case types.REMOVING_USER_LOCATION:
      return {
        ...state,
        isFetching: true,
        status: 'OK',
      }
    case types.USER_LOCATION_REMOVED:
      const deleteLocationUpdateFranchises = { ...state.franchises };
      state.franchises[payload.franchise].locations.forEach((location, index) => {
        if (location.address !== payload.location) return;
        deleteLocationUpdateFranchises[payload.franchise].locations[index].managers = payload.locationManagers;
        deleteLocationUpdateFranchises[payload.franchise].locations[index].technicianAssigned = payload.technicianAssigned;
      })
      const deleteLocationUpdateUsers = { ...state.users };
      deleteLocationUpdateUsers[payload.uid].assignedLocations = payload.locations;
      return {
        ...state,
        isFetching: false,
        status: 'OK',
        franchises: deleteLocationUpdateFranchises,
        users: deleteLocationUpdateUsers,
      }
    case types.ERROR_REMOVING_USER_LOCATION:
      return {
        ...state,
        isFetching: false,
        status: 'ERROR',
      }

      case types.DELETING_FRANCHISE:
        return {
          ...state,
          isFetching: true,
          status: 'OK'
        }
      case types.FRANCHISE_DELETED:
        const franchisesWithoutDeleted = { ...state.franchises };
        const locationsWithoutDeleted = franchisesWithoutDeleted[payload.franchise].locations.filter(location => location.address !== payload.address)
        franchisesWithoutDeleted[payload.franchise].locations = locationsWithoutDeleted
        return {
          ...state,
          franchises: franchisesWithoutDeleted,
          isFetching: false,
          status: 'OK',
        }

    case types.SET_CHARTS:
      return {
        ...state,
        checklistsCompletedChart: payload.checklistsCompletedChart,
        checklistsOnTimeChart: payload.checklistsOnTimeChart,
        checklistsPassedChart: payload.checklistsPassedChart,
        customerSatisfactionChart: payload.customerSatisfactionChart,
        status: "OK",
      };

    case types.SET_CALENDAR:
      return {
        ...state,
        calendar: payload,
        status: 'OK',
      }

    case types.SET_OVERALL_INFORMATION:
      return {
        ...state,
        statistics: payload,
        status: "OK",
      };

    case types.ADD_PAST_CHECKLISTS:
      const newPastChecklists = {
        ...state.pastChecklists,
        [Object.keys(payload)[0]]: {
          ...state.pastChecklists[Object.keys(payload)[0]],
          ...payload[Object.keys(payload)[0]],
        }
      };
      return {
        ...state,
        pastChecklists: newPastChecklists,
        isFetching: false,
        status: "OK",
      };

    case types.SET_LIMIT_REACHED:
      return {
        ...state,
        limitReached: true,
        status: "OK",
      };

    case types.SET_FRANCHISES:
      return {
        ...state,
        franchises: payload,
        status: "OK",
      };

    case types.CLEAR_CHECKLIST:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default checklistReducer;
